import React, { Component } from 'react'
import Language from './language'

// Constants
import { DEFAULT_LOCALE } from '../../dashboard/constants'

// Components
import Hamburger from './toolbar/hamburger'
import Menu from 'components/dashboard/shared/menu'

export default class Toolbar extends Component {
  onSidebarExpand() {
    this.props.onSidebarExpand()
  }

  render() {
    return (
      <header className='toolbar'>
        <Hamburger onSidebarExpand={this.onSidebarExpand.bind(this)} />

        <nav>
          <a
            href={
              this.props.locale === DEFAULT_LOCALE
                ? '/login'
                : `/${this.props.locale}/login`
            }
            className='toolbar__title_link'
          ></a>

          <div className='toolbar__panel'>
            <div className='toolbar__locales'>
              <Language locale={this.props.locale} region={this.props.region} />
            </div>
          </div>

          <Menu
            className='toolbar__menu'
            locale={this.props.locale}
            region={this.props.region}
            resources={this.props.resources}
          />
        </nav>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/application/layout/toolbar.js